/** Every named query that shows supplier-to-client links; mutations that change links refetch them all. */
export const SUPPLIER_LINK_QUERIES = [
  // Every table's row count runs under this shared name; without it the rows refresh but the count does not.
  'GraphqlDataTablePaginationQuery',
  'SupplierClientsTableQuery',
  'ClientRecruitersTableQuery',
  'CompanyRecruitersTableQuery',
  'LinkStaffingAgencyLinkedCount',
  'SupplierClientAgencyCounts',
  'ClientRelationDrawer',
  'SupplierClientPage',
  'ClientOverviewData',
  'ClientPeopleCounts',
  'ClientAgencyRecruitersTableQuery',
  'ClientDrawerContacts',
]
